import _ from 'lodash'

const findByValue = (statusCodes, v) =>
  _.find(statusCodes, ({ value }) => value === v)
const findByText = (statusCodes, t) =>
  _.find(statusCodes, ({ text }) => text === t)

const statusCodeToText = (statusCodes, code) => {
  const statusCode = findByValue(statusCodes, code)
  if (!statusCode) {
    return 'unknown'
  }
  return statusCode.text
}

const statusTextToCode = (statusCodes, text) => {
  const statusCode = findByText(statusCodes, text)
  if (!statusCode) {
    return 0
  }
  return statusCode.value
}

const diamondStatusCodes = {
  AVAILABLE: {
    value: 1,
    text: 'available'
  },
  RESERVED: {
    value: 2,
    text: 'reserved'
  },
  HIDDEN: {
    value: 3,
    text: 'hidden'
  },
  SOLD: {
    value: 4,
    text: 'sold'
  },
  SOLD_IN: {
    value: 4,
    text: 'sold'
  },
  SOLD_OUT: {
    value: 5,
    text: 'sold'
  },
  DELETED: {
    value: 6,
    text: 'deleted'
  },
  PRIVATE: {
    value: 7,
    text: 'private'
  }
}

const retailerStatusCodes = {
  AVAILABLE: {
    value: 1,
    text: 'available'
  },
  DELETED: {
    value: 2,
    text: 'deleted'
  },
  PRIVATE: {
    value: 3,
    text: 'private'
  }
}

export default {
  diamond: {
    statusCodes: diamondStatusCodes,
    statusCodeToText: statusCodeToText.bind(null, diamondStatusCodes),
    statusTextToCode: statusTextToCode.bind(null, diamondStatusCodes)
  },
  retailer: {
    statusCodes: retailerStatusCodes,
    statusCodeToText: statusCodeToText.bind(null, retailerStatusCodes),
    statusTextToCode: statusTextToCode.bind(null, retailerStatusCodes)
  }
}
